import { useContext, useState } from "react";
import classes from "./ViewTask.module.scss";
import Modal from "../Modal/Modal";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

const ViewTask = () => {
  const { modalPayload, openModal } = useContext(ModalContext);
  const { boards, toggleSubtask, editTask } = useContext(BoardContext);
  const { boardId, columnId, taskId } = modalPayload;
  const [menuIsShown, setMenuIsShown] = useState(false);

  const board = boards.find((b) => b.id === boardId);
  const column = board?.columns.find((col) => col.id === columnId);
  const task = column?.tasks.find((t) => t.id === taskId);

  if (!board || !column || !task) return null;

  const completedCount = task.subTasks.filter((st) => st.isCompleted).length;

  const handleStatusChange = (e) => {
    const newColumnId = e.target.value;
    if (newColumnId !== column.id) {
      editTask(boardId, taskId, {}, newColumnId);
      openModal("viewTask", { boardId, columnId: newColumnId, taskId });
    }
  };

  return (
    <Modal>
      <section className={classes.view_task}>
        <section className={classes.subtask_heading}>
          {menuIsShown && (
            <section className={classes.edit_task_menu} style={{ display: "block" }}>
              <button
                type="button"
                className={classes.edit_task}
                onClick={() => openModal("editTask", { boardId, columnId, taskId })}
              >
                Edit Task
              </button>
              <button
                type="button"
                className={classes.delete_task}
                onClick={() => openModal("deleteTask", { boardId, columnId, taskId })}
              >
                Delete Task
              </button>
            </section>
          )}
          <p className={classes.subtask}>{task.title}</p>
          <button
            type="button"
            aria-label="Task options"
            className={classes.ellipsisButton}
            onClick={() => setMenuIsShown((prev) => !prev)}
          >
            <FontAwesomeIcon icon={faEllipsisVertical} className={classes.ellipsisVertical} aria-hidden="true" />
          </button>
        </section>
        <p className={classes.subtask_description}>{task.description}</p>
        <section className={classes.subtasks}>
          <h3 className={classes.subtasks_heading}>
            Subtasks ({completedCount} of {task.subTasks.length})
          </h3>
          <section className={classes.subtasks_todoList}>
            {task.subTasks.map((subtask) => (
              <div className={classes.subtask_item} key={subtask.id}>
                <input
                  type="checkbox"
                  checked={subtask.isCompleted}
                  onChange={() => toggleSubtask(boardId, columnId, taskId, subtask.id)}
                />
                <label
                  className={subtask.isCompleted ? classes.done : classes.undone}
                >
                  {subtask.title}
                </label>
              </div>
            ))}
          </section>
        </section>
        <section className={classes.task_status}>
          <p>Current Status</p>
          <select
            name="status"
            id="status"
            className={classes.status}
            value={column.id}
            onChange={handleStatusChange}
          >
            {board.columns.map((col) => (
              <option key={col.id} value={col.id}>
                {col.name}
              </option>
            ))}
          </select>
        </section>
      </section>
    </Modal>
  );
};

export default ViewTask;
